import React from 'react';
import FieldHelp from './FieldHelp';

interface LabelWithHelpProps {
    htmlFor?: string;
    help?: string | null;
    className?: string;
    children: React.ReactNode;
}

/**
 * Form label with an optional inline FieldHelp tooltip.
 */
const LabelWithHelp = (props: LabelWithHelpProps) => {
    const { htmlFor, help, className, children } = props;

    return (
        <label
            htmlFor={htmlFor}
            className={className || 'inline-flex items-center gap-1 text-sm font-medium leading-6 text-gray-900 dark:text-gray-100'}
        >
            <span className="inline-flex items-center gap-1">
                {children}
                <FieldHelp content={help} />
            </span>
        </label>
    );
};

export default LabelWithHelp;
